import script from "./PrintGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./PrintGroup.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__